import React from "react";

function AppUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#f5fcff"
        d="M149.5 504.5c-20.711 0-37.5-16.789-37.5-37.5V45c0-20.711 16.789-37.5 37.5-37.5h213C383.211 7.5 400 24.289 400 45v422c0 20.711-16.789 37.5-37.5 37.5z"
        data-original="#f5fcff"
      ></path>
      <path
        fill="#e0f5fc"
        d="M397.09 481.5c-5.66 13.51-19.02 23-34.59 23h-213c-20.71 0-37.5-16.79-37.5-37.5V45c0-15.57 9.49-28.93 23-34.59V467c0 8 6.5 14.5 14.5 14.5z"
        data-original="#e0f5fc"
      ></path>
      <circle
        cx="293.5"
        cy="37.5"
        r="7.415"
        fill="#5f6c75"
        data-original="#5f6c75"
      ></circle>
      <path
        fill="#5f6c75"
        d="M362.5 512h-213c-24.813 0-45-20.187-45-45V45c0-24.813 20.187-45 45-45h213c24.813 0 45 20.187 45 45v422c0 24.813-20.187 45-45 45zm-213-497c-16.542 0-30 13.458-30 30v422c0 16.542 13.458 30 30 30h213c16.542 0 30-13.458 30-30V45c0-16.542-13.458-30-30-30z"
        data-original="#5f6c75"
      ></path>
      <path
        fill="#5f6c75"
        d="M268.5 45h-50c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h50c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
        data-original="#5f6c75"
      ></path>
      <path
        fill="#b3e59f"
        d="M313 403.5H199c-7.732 0-14 6.268-14 14v23c0 7.732 6.268 14 14 14h114c7.732 0 14-6.268 14-14v-23c0-7.732-6.268-14-14-14zM148.574 229.809s34.25 103.489 97.211 103.489c31.941 0 71.528-1.934 92.225-23.099 20.1-20.554 32.489-48.68 32.489-79.699 0-62.96-51.04-114-114-114-32.774 0-62.317 13.83-83.113 35.972-19.154 20.395-24.812 77.337-24.812 77.337z"
        data-original="#b3e59f"
      ></path>
      <path
        fill="#95d6a4"
        d="M349.07 297.03c-20.68 28.75-54.44 47.47-92.57 47.47-62.96 0-114-51.04-114-114 0-36.31 16.98-68.66 43.43-89.53-13.49 18.72-21.43 41.7-21.43 66.53 0 62.96 51.04 114 114 114 26.65 0 51.16-9.14 70.57-24.47z"
        data-original="#95d6a4"
      ></path>
      <path
        fill="#ccf49f"
        d="M242.499 288.25a14.95 14.95 0 01-10.606-4.394l-45.5-45.5c-6.028-6.028-5.853-15.91.525-21.714 5.974-5.436 15.277-4.91 20.988.801l32.472 32.472a3 3 0 004.243 0l60.472-60.472c5.711-5.711 15.014-6.237 20.988-.801 6.378 5.804 6.553 15.686.525 21.714l-73.5 73.5a14.954 14.954 0 01-10.607 4.394z"
        data-original="#ccf49f"
      ></path>
      <path
        fill="#f5fcff"
        d="M242.075 283.904a14.95 14.95 0 01-10.606-4.394l-41.191-42.962c-6.028-6.028-9.737-14.103-3.359-19.907 5.974-5.436 15.277-4.91 20.988.801l32.472 32.472c1.172 1.172 7.281 3.341 8.452 2.17l56.936-58.149s14.34-10.729 20.314-5.294c6.378 5.804 6.553 15.686.525 21.714l-73.5 73.5c-2.929 2.93-7.193.049-11.031.049z"
        data-original="#f5fcff"
      ></path>
      <path
        fill="#e0f5fc"
        d="M253 283.96a14.944 14.944 0 01-10.5 4.29c-3.84 0-7.68-1.47-10.61-4.39l-45.5-45.5c-6.03-6.03-5.85-15.91.53-21.72.71-.64 1.46-1.2 2.24-1.67a14.88 14.88 0 004.09 7.62l59.64 61.27c.04.04.07.07.11.1zm73.51-94.91c-.14.12-.28.25-.42.39l-70.96 70.92a3 3 0 01-4.24 0l-10.13-10.13c1.17.85 2.81.74 3.86-.31l60.47-60.48c5.71-5.71 15.02-6.23 20.99-.8.15.13.29.27.43.41z"
        data-original="#e0f5fc"
      ></path>
    </svg>
  );
}

export default AppUser;